import { FormBuilderBufferContext } from 'src/features/generalForms/context/formBuilderBuffer.context';
import { useContextSelector } from 'use-context-selector';

export const useNodeBuffer = () => {
  const buffer = useContextSelector(FormBuilderBufferContext, (x) => x.buffer);
  const addToBuffer = useContextSelector(FormBuilderBufferContext, (x) => x.addToBuffer);
  const removeFromBuffer = useContextSelector(FormBuilderBufferContext, (x) => x.removeFromBuffer!);

  return { buffer, addToBuffer, removeFromBuffer };
};
